import type { Locale } from "shared-core/services/i18n.ts";
import { configOptions } from "shared-ui/utils/cookie-consent.ts";
import type { CookieConsentConfig, Translation } from "vanilla-cookieconsent";

export function createCookieConsentConfig(
  translate: (key: string, locale: Locale) => string,
  locale: string,
  hostname: string,
  privacyPolicyHref: (locale: string) => string,
  prepareLanguage?: (locale: Locale) => Promise<void>,
): CookieConsentConfig {
  const translation = (language: Locale): Translation => {
    const t = (key: string): string =>
      translate(`cookie_consent.${key}`, language);
    return {
      consentModal: {
        title: t("title"),
        description: t("description"),
        acceptAllBtn: t("accept_all"),
        acceptNecessaryBtn: t("necessary_only"),
        showPreferencesBtn: t("manage_preferences"),
      },
      preferencesModal: {
        title: t("preferences_title"),
        acceptAllBtn: t("accept_all"),
        acceptNecessaryBtn: t("necessary_only"),
        savePreferencesBtn: t("save_preferences"),
        closeIconLabel: t("close"),
        sections: [
          {
            title: t("necessary_title"),
            description: t("necessary_description"),
            linkedCategory: "necessary",
          },
          {
            title: t("analytics_title"),
            description: t("analytics_description"),
            linkedCategory: "analytics",
          },
          {
            title: t("more_information"),
            description: `<a href="${privacyPolicyHref(language)}">${t("privacy_policy")}</a>`,
          },
        ],
      },
    };
  };

  return {
    ...configOptions,
    cookie: {
      ...configOptions.cookie,
      domain:
        hostname === "controla.ai" || hostname.endsWith(".controla.ai")
          ? "controla.ai"
          : hostname,
    },
    guiOptions: {
      ...configOptions.guiOptions,
      consentModal: {
        layout: "box",
        position: "bottom right",
        equalWeightButtons: false,
      },
    },
    language: {
      default: locale,
      translations: {
        en: async (): Promise<Translation> => {
          await prepareLanguage?.("en");
          return translation("en");
        },
        sv: async (): Promise<Translation> => {
          await prepareLanguage?.("sv");
          return translation("sv");
        },
      },
    },
  };
}
